import React from "react";
import PropTypes from "prop-types";

import Label from "ui/text/Label";

import { TextField } from "@mui/material";

const NotificationList = ({ notification_list, onChange }) => {

  const label = "Notification List";
  const helperText =
    "Enter one or more valid email addresses, separated by commas. " +
    "We will notify them of every purchase made in your store, and send them billing, payout and weekly report emails.";

  return (
    <>
      <TextField
        fullWidth
        size="small"
        color="warning"
        name="notification_list"
        value={notification_list}
        onChange={onChange}
        label={label}
      />

      <Label secondary padded>
        {helperText}
      </Label>
    </>
  );
};

NotificationList.propTypes = {
  notification_list: PropTypes.string,
  onChange: PropTypes.func,
};

export default NotificationList;
